import { allActivities, resetState } from "@appStore/reducers/activity.ts";
import store from "@appStore/store";
import { mapping } from "actions/mapping";
import { httpRequest } from "api/httpRequest";
import { CONSTS } from "config/objectConst";

export const apiActivity = {
  getActivities: async (data) => {
    const { take } = { ...data };
    const params = `?${take ? "&$take=" + take : ""}`;
    try {
      const response = await httpRequest({
        url: `${CONSTS.API.URL}workspace/activities-queue${params}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (response.data) {
        store.dispatch(
          allActivities({
            activity: response.data
              ? mapping.buildActivity(response.data.documents)
              : [],

            total: response.data.total,
          })
        );
      }

      if (!response.data) {
        store.dispatch(resetState());
      }
    } catch (error) {
      store.dispatch(resetState());
      throw error;
    }
  },
};
